import { EstimateAndQuoteDetailViewModel } from '@models/EstimateAndQuoteDetail';

export const calculateEstimateGrandTotal = (
  details: EstimateAndQuoteDetailViewModel[],
  discount: number,
  discountType?: number,
  isTaxExempt?: boolean
): number => {
  const subtotal = details.reduce((acc, cur) => acc + cur.subTotal, 0);

  const taxesTotal = isTaxExempt
    ? 0
    : details
        .map((detail) =>
          detail.estimateDetailSalesTaxes.reduce(
            (acc, tax) => acc + tax.salesTaxAmount,
            0
          )
        )
        .reduce((acc, cur) => acc + cur, 0);

  const subtotalWithTax = subtotal + taxesTotal;

  // Calculate discount amount based on discount type
  let discountAmount = 0;
  if (discountType === 2) {
    // Percentage
    discountAmount = (subtotalWithTax * discount) / 100;
  } else {
    // Amount (default)
    discountAmount = discount;
  }

  return subtotalWithTax - discountAmount;
};
